export const shouldForceRequote = (name) => !['part_number',
  'revision',
  'special_instructions',
  'gerber_file_name',
  'filename',
  'email_address',
].includes(name);
